import animationStyles from './styles/product.videoAnimation.module.scss';
import React, { useState } from 'react';
import { clsx } from '../../../../utils/clsx';
import { getSrcSetForLazy } from '../../../../utils/getSrcSetForLazy';
import { ppData } from '../../configs/ppData.config';
import { FlatPreview } from './FlatPreview';
export const MainImageMobile = ({ image, isVideo, nbOfItems, currentIndex, setImage, setNextImage, setPrevImage }) => {
    const [startPos, setStartPos] = useState({ x: 0, y: 0 });
    const touchStartHandler = ({ touches }) => {
        setStartPos({ x: touches[0].clientX, y: touches[0].clientY });
    };
    const touchEndHandler = ({ changedTouches }) => {
        const xDistance = startPos.x - changedTouches[0].clientX;
        const yDistance = startPos.y - changedTouches[0].clientY;
        if (Math.abs(yDistance) > Math.abs(xDistance) || Math.abs(xDistance) < 30)
            return;
        xDistance < 0 ? setPrevImage() : setNextImage();
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "pos:r z:1 btn:cleared w:100p image-wrapper bdrs:1 ov:h bg:f4f4f4", onTouchStart: touchStartHandler, onTouchEnd: touchEndHandler },
            React.createElement("div", { className: clsx('pos:a l:0 t:0 h:100p w:100p', isVideo && animationStyles.videoAnimationImage) }, typeof image === 'string'
                ? React.createElement("img", { className: "image:cover", src: image, srcSet: getSrcSetForLazy(image, 2376), sizes: "100vw", height: 702, width: 702, alt: ppData.originalTitle })
                : React.createElement(FlatPreview, { data: image, srcSetMaxSize: 2376, imageAlt: ppData.originalTitle }))),
        nbOfItems > 0 && !isVideo &&
            React.createElement("ul", { className: `list:none pos:a z:2 ${ppData.isOldCustom ? 'l:50p trf:tx:-50p' : 'r:112'} b:14 d:flex ai:center h:28 px:4 bxsh:2 bdrs:24 bg:white` }, [...Array(nbOfItems)].map((v, index) => (React.createElement("li", { key: index },
                React.createElement("button", { className: "btn:cleared p:4", onClick: () => { setImage(index); } },
                    React.createElement("i", { className: `d:block bdrs:50p h:10 w:10 ${index === currentIndex ? 'bg:color-text' : 'bg:border'}` })))))));
};
